import { TaxDocumentFormat } from "./generated/graphql";

/**
 * Maps the tax-forms UI's lowercase file-format strings onto the GraphQL
 * TaxDocumentFormat enum. "8233" becomes X8233 because enum names cannot
 * start with a digit.
 */
const TAX_DOCUMENT_FORMAT_BY_FILE_FORMAT: Record<string, TaxDocumentFormat> = {
  w8: TaxDocumentFormat.W8,
  w9: TaxDocumentFormat.W9,
  "8233": TaxDocumentFormat.X8233,
};

export function toTaxDocumentFormat(fileFormat: string): TaxDocumentFormat {
  const formType =
    TAX_DOCUMENT_FORMAT_BY_FILE_FORMAT[fileFormat.toLowerCase()];
  if (!formType) {
    throw new Error(`Unsupported tax form format: ${fileFormat}`);
  }
  return formType;
}
